export default __webpack_public_path__ + "static/media/envelope.3b9edb04.svg";